<template>
  <div class="main-box main-content">
    <el-dialog :title="dialogName" :visible.sync="dialogVisible" width="600px" :close-on-click-modal="false">
      <el-form ref="dataForm" id="dataForm" :model="temp" :rules="rules" label-width="100px" label-suffix="：">
        <template-item
          v-for="(element, index) in itemList"
          ref="draggableItem"
          :title="element.itemRef"
          :key="element.renderKey"
          :item-list="temp.itemList"
          :element="element"
          :index="index"
          :form-conf="temp"
        />
      </el-form>
      <div slot="footer" class="dialog-footer">
        <xr-button type="primary" @click="save('dataForm')">确定</xr-button>
        <xr-button type="default" @click="dialogVisible = false">取消</xr-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
    import TemplateItem from "./common/template-item.vue";
    export default {
        name: "templateAdd",
        data() {
          return {
            dialogName: '修改',
            dialogVisible: false,                                       //弹框
            url1: '',                                                   //保存方法的地址
            url2: '',                                                   //保存方法的地址
            temp:{},
            itemList: [],
            rules: {}
          }
        },
        components: {
          TemplateItem
        },
        methods: {
          init(pageId, id){
            return this.request({
              method:'post',
              url:'/web/service',
              params:{
                'method': 'tGenerateTemplate_getSaveInfo',
                pageId: pageId
              }
            }).then((response) =>{          //这里使用了ES6的语法
              // 请求成功返回的数据
              //如果返回编码不为0，提示失败语
              if(response.code != '0'){
                this.$message.error(response.msg);
                return false;
              }
              if(!response.data.pageInfo){
                this.$message.error('页面设计错误！');
                return false;
              }
              let info = response.data.pageInfo;
              this.url1 = '/web/service?method=' + info.dataServerKey1
              this.url2 = '/web/service?method=' + info.dataServerKey2
              this.primaryKey = info.primaryKey
              this.dialogVisible = true;

              let params = new Object();
              params['type'] = 'edit';
              params[this.primaryKey] = id;

              return this.request({
                method: 'post',
                url: this.url2,
                params: params
              }).then((response1) =>{          //这里使用了ES6的语法
                // 请求成功返回的数据
                //如果返回编码不为0，提示失败语
                if(response1.code != '0'){
                  this.$message.error(response1.msg);
                  return false;
                }
                if(response1.data && response1.data.info){
                  this.temp = response1.data.info;
                }

                if(response.data && response.data.itemList){
                  let itemList = response.data.itemList;
                  for(let i = 0 ; i < itemList.length; i ++){
                    itemList[i]['defaultValue'] = this.temp[itemList[i]['vModel']];
                  }
                  this.itemList = itemList;
                }

              })
            })
          },

          save(formName){
            this.$refs[formName].validate((valid) => {
              if (valid) {
                return this.request({
                  method: 'post',
                  url: this.url1,
                  params: this.temp
                }).then((response) =>{
                  if (response.code === 0) {
                    this.$message({
                      message: '操作成功',
                      type: 'success',
                      duration: 1500,
                      onClose: () => {
                        this.dialogVisible = false
                        this.$emit('callBackMethod')
                      }
                    })
                  } else {
                    this.$message.error(response.msg)
                  }
                })
              } else {
                console.log('error submit!!');
                return false;
              }
            });
          },
          //重置
          resetTemp() {
            this.$nextTick(() => {      //清空校验
              this.$refs['dataForm'].clearValidate()
            })
          },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/template/edit.vue